import { AppService } from "app/services/app.service";

import { Observable } from "rxjs";

export abstract class AbEstadoCivil extends AppService {
  abstract getAllEstadosCivis(): Observable<any>;

}